import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '../../shared/pipes/translate.pipe';

/**
 * Confirmation dialog for removing a field from the form builder.
 * Used as a stacked modal on top of the field editor modal.
 */
@Component({
  selector: 'app-remove-field-confirmation',
  standalone: true,
  imports: [TranslatePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <div class="p-lg">
      <p [innerHTML]="'formBuilder.deleteField.confirm' | translate: { label: fieldLabel }"></p>
      <p class="text-sm" style="color: var(--color-danger); margin-top: var(--margin-md);">
        {{ 'formBuilder.deleteField.warning' | translate }}
      </p>
    </div>
  `,
})
export class RemoveFieldConfirmationComponent {
  @Input() fieldLabel = '';
}
